import { IReduxState } from 'state/types';

import { NAME } from './constants';

export const getTitle = (state: IReduxState) => state?.[NAME]?.title;
export const getSubtitle = (state: IReduxState) => state?.[NAME]?.subtitle;
